import NavBar from "./NavBar";
import Noe from "../images/noe.jpg";
import Agus from "../images/agus.jpg";
import Flor from "../images/flor.jpg";
import LinkedIn from "../images/linkedin.svg";
import JS from "../images/js.svg";
import CSS from "../images/css3.svg";
import Bootstrap from "../images/bootstrap.svg";
import MySQL from "../images/mysql.svg";
import Sequelize from "../images/sequelize.svg";
import Node from "../images/node.svg";
import ReactLogo from "../images/react.svg";
import Redux from "../images/redux.svg";
import Express from "../images/express.svg";
import JWT from "../images/jwt.svg";
import Vercel from "../images/vercel.svg";
import Supabase from "../images/supabase.svg";
import Github from "../images/github.svg";
import Figma from "../images/figma.svg";
import Trello from "../images/trello.svg";

import CarouselScreenshots from "./CarouselScreenshots";
import CarouselAdmin from "./CarouselAdmin";

import "./aboutThisProject.css";

function AboutThisProject() {
  return (
    <div>
      <NavBar />
      <div className="container mt-5">
        <div className="row d-flex justify-content-evenly mx-md-n5 mt-5">
          <div className="mt-5 p-3 col-12 px-md-5 ms-3 me-3">
            <h1 className="fw-bold color-green">About this Project</h1>
          </div>
          <hr />
          <div className="mt-3 p-3 col-10 col-md-5 px-md-5 ms-3 me-3">
            <h3 className="fw-bold text-start mb-3">Challenges</h3>
            <p className="fs-5 text-start">
              Hackoffee is our final project of Hack Academy's Coding Bootcamp,
              which took place between April and July, 2022 and consisted on a
              three months full time training course. The project consisted in
              creating an E-commerce during 3 weeks to apply our knowledge as
              full stack developers.
            </p>
            <p className="fs-5 text-start">
              Our shop sells exclusive coffee, tea and sweets and we decided to
              make a clean design with big attractive images. The Front-End is
              divided in two parts: customer and admin. The Back-End consists on
              an API connected to a SQL database.
            </p>
          </div>
          <div className="mt-3 p-3 col-10 col-md-5 px-md-5 ms-3 me-3">
            <h3 className="fw-bold text-start mb-3">
              Organization & References
            </h3>
            <p className="fs-5 text-start">
              We used Figma, Trello and GitHub to organize our work.
            </p>

            <div>
              <img className="tech__image m-2" src={Figma} alt="figma"></img>
              <img className="tech__image m-2" src={Trello} alt="trello"></img>
              <img className="tech__image m-2" src={Github} alt="github"></img>
            </div>

            <p className="fs-5 text-start mt-3">
              We combined culto cafe as reference with little's coffee, and the
              images of these project where taken from Sinfonia, Kofio and
              Laderach, and where used for educational purposes only.
            </p>
          </div>
          <hr />
          <div className="row d-flex align-items-center mx-md-n5 mt-5">
            <h3 className="fw-bold text-center mb-3">User Interface</h3>
            <p className="fs-5">
              As a user, you can navigate through product categories, view
              product details and add products to cart. In the shopping cart you
              may see and delete or modify quantities of added products. To be
              able to proceed to checkout you must be registered to the website
              as a costumer. In the profile section you can see your account
              details and your orders with their status.
            </p>
            <div className="mt-5 p-3 col-12 d-flex align-items-center px-md-5 ms-3 me-3 mb-5">
              <CarouselScreenshots />
            </div>
          </div>
          <hr />
          <div className="row d-flex align-items-center mx-md-n5 mt-5">
            <h3 className="fw-bold text-center mb-3">Admin panel</h3>
            <p className="fs-5">
              As an administrator you can view the control panel with the
              dashboard, edit and delete categories and products and see all
              orders with their status.
            </p>
            <div className="mt-5 p-3 col-12 d-flex align-items-center px-md-5 ms-3 me-3 mb-5">
              <CarouselAdmin />
            </div>
          </div>
          <hr />
          <div className="row d-flex justify-content-between mx-md-n5">
            <div className="mt-5 p-3 col-12 px-md-5 ms-3 me-3 mb-3">
              <h3 className="fw-bold text-center mb-5">Technologies used</h3>
              <div className="row ">
                <div className="col-md-12 text-center">
                  <div className="row d-flex justify-content-between">
                    <div className="col-md-2 col-6 ">
                      <img className="tech__image m-2" src={JS} alt="js"></img>
                      <h6>Javascript</h6>
                    </div>
                    <div className="col-md-2 col-6 ">
                      <img
                        className="tech__image m-2"
                        src={CSS}
                        alt="css"
                      ></img>
                      <h6>CSS</h6>
                    </div>
                    <div className="col-md-2  col-6 ">
                      <img
                        className="tech__image m-2"
                        src={Bootstrap}
                        alt="Bootstrap"
                      ></img>
                      <h6>Bootstrap</h6>
                    </div>
                    <div className="col-md-2 col-6 ">
                      <img
                        className="tech__image m-2"
                        src={MySQL}
                        alt="MySQL"
                      ></img>
                      <h6>MySQL</h6>
                    </div>
                    <div className="col-md-2 col-6 ">
                      <img
                        className="tech__image m-2"
                        src={Sequelize}
                        alt="Sequelize"
                      ></img>
                      <h6>Sequelize</h6>
                    </div>
                    <div className="col-md-2 col-6 ">
                      <img
                        className="tech__image m-2"
                        src={Node}
                        alt="Node"
                      ></img>
                      <h6>Node JS</h6>
                    </div>
                  </div>
                  <div className="row d-flex justify-content-between">
                    <div className="col-md-2 col-6 ">
                      <img
                        className="tech__image m-2"
                        src={Express}
                        alt="Express"
                      ></img>
                      <h6>Express</h6>
                    </div>
                    <div className="col-md-2 col-6 ">
                      <img
                        className="tech__image m-2"
                        src={JWT}
                        alt="JSON Web Token"
                      ></img>
                      <h6>Express JS</h6>
                    </div>
                    <div className="col-md-2 col-6 ">
                      <img
                        className="tech__image m-2"
                        src={ReactLogo}
                        alt="ReactLogo"
                      ></img>
                      <h6>React</h6>
                    </div>
                    <div className="col-md-2 col-6 ">
                      <img
                        className="tech__image m-2"
                        src={Redux}
                        alt="Redux"
                      ></img>
                      <h6>Redux</h6>
                    </div>
                    <div className="col-md-2 col-6 ">
                      <img
                        className="tech__image m-2"
                        src={Vercel}
                        alt="Vercel"
                      ></img>
                      <h6>Vercel</h6>
                    </div>
                    <div className="col-md-2 col-6 ">
                      <img
                        className="tech__image m-2"
                        src={Supabase}
                        alt="Supabase"
                      ></img>
                      <h6>Supabase</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div className="row d-flex justify-content-between mx-md-n5 mt-5">
            <h3 className="fw-bold text-center mb-3">Hackoffee's team:</h3>
            <div className="mt-5 p-3 col-10 col-md-3 px-md-5 ms-3 me-3 mb-2">
              <img className="team__image" src={Noe} alt="profile pic"></img>
              <h5 className="fw-bold mt-3">Noelia Caballero</h5>
              <a
                href="https://www.linkedin.com/in/noelia-caballero/"
                target="_blank"
              >
                <img
                  className="iconLinkedIn"
                  src={LinkedIn}
                  alt="LinkedIn"
                ></img>
              </a>
            </div>
            <div className="mt-5 p-3 col-10 col-md-3 px-md-5 ms-3 me-3 mb-2">
              <img className="team__image" src={Agus} alt="profile pic"></img>
              <h5 className="fw-bold mt-3">Agustín Demaría</h5>
              <a
                href="https://www.linkedin.com/in/agustindemaria/"
                target="_blank"
              >
                <img
                  className="iconLinkedIn"
                  src={LinkedIn}
                  alt="LinkedIn"
                ></img>
              </a>
            </div>
            <div className="mt-5 p-3 col-10 col-md-3 px-md-5 ms-3 me-3 mb-5">
              <img className="team__image" src={Flor} alt="profile pic"></img>
              <h5 className="fw-bold mt-3">Florencia Acquarone</h5>
              <a
                href="https://www.linkedin.com/in/florencia-acquarone/"
                target="_blank"
              >
                <img
                  className="iconLinkedIn"
                  src={LinkedIn}
                  alt="LinkedIn"
                ></img>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutThisProject;
